// SVG Style Plugin
import { createColorProperty } from "./helpers.js";
export default {
    id: 'svg',
    label: 'SVG',
    icon: 'Image',
    properties: {
        fill: {
            label: 'Fill',
            type: 'color',
            default: null,
            ...createColorProperty('fill')
        },
        stroke: {
            label: 'Stroke',
            type: 'color',
            default: null,
            ...createColorProperty('stroke', ['0', '1', '2'])
        },
        strokeWidth: {
            label: 'Stroke Width',
            type: 'select',
            options: ['0', '1', '2'],
            default: '1',
            toClass: (value) => value ? `stroke-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^stroke-([0-2])$/);
                return match ? match[1] : null;
            }
        }
    }
};
